// @ts-nocheck
document.addEventListener("alpine:init", () => {
    /**
       * @param {{product: {selling_plan_allocations: Array<{selling_plan_id: number | null}>}}} product
    */
    Alpine.data("productForm", function ({ variant = {} }) {
      return {
        variant,
        sellingPlanId: null,
        isAddedToCart: false,
        maxQuantity: 99,
        formattedPrice: 0,
        cartItem: null,
        cartProduct: null,
        toggleQuantityBox: false,
        loading: true,
        totalPrice: 0,
        quantity: 1,

/**
 * Format price like Shopify's money filter
 * @param {number|string} cents - Price in cents or dollars
 * @param {string} format - Format string (default: '$[[amount]]')
 * @returns {string} Formatted price string
 */
formatMoney(cents, format = '$[[amount]]') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  let value = '';
  const placeholderRegex = /\[\[\s*(\w+)\s*\]\]/;
  const formatString = format || '$[[amount]]';
  
  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return '0';
    }
    
    number = (number / 100.0).toFixed(precision);
    
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';
    
    return dollarsAmount + centsAmount;
  }
  
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  
  return formatString.replace(placeholderRegex, value);
},

        initCartItem(cartProduct) {
          this.loading = false;
          this.toggleQuantityBox = !!cartProduct;

          if (cartProduct) {
            this.quantity = cartProduct.quantity || 1;
            this.totalPrice = cartProduct.price * this.quantity;
          }
        },

        init() {
          this.sellingPlanId = this.handleSellingPlanChange(
            this.$store.cartDrawerStore.sellingPlan
          );

          this.cartProduct = this.getCartProduct(this.$store.cartDrawerStore.products) || null;
          this.loading = false;
          this.toggleQuantityBox = this.cartProduct !== null;

          if (this.cartProduct) {
            this.totalPrice = this.cartProduct.price * this.quantity;
          }

          this.$watch(
            () => this.$store.cartDrawerStore.sellingPlan, /** @param {number | null} sellingPlanId */
    (sellingPlanId) => {
              this.handleSellingPlanChange(sellingPlanId);
            }
          );

          this.$watch('$store.cartDrawerStore.products',(value, oldvalue)=>{
            this.cartProduct = this.getCartProduct(value) || null;
            this.loading = false;
            this.toggleQuantityBox = this.cartProduct !== null;
            if (this.cartProduct) {
              this.totalPrice = this.cartProduct.price * this.quantity;
            }
          });
        },

        getCartProduct(products) {
          const cartProduct = products.find((product) => product.id === this.variant.id);
          if (cartProduct) {
            this.quantity = cartProduct.quantity || 1;
            this.totalPrice = cartProduct.price * this.quantity;
          }
          return cartProduct;
        },

        increaseQuantity() {
          if (this.quantity < this.maxQuantity) {
            this.quantity = this.quantity + 1;
          }
          this.updateCart();
          window.dispatchEvent(new CustomEvent('cart-drawer-store:show-notification'));
        },
        decreaseQuantity() {
          if (this.quantity >= 1) {
            this.quantity = this.quantity - 1;
            this.updateCart();
          }
        },

        getProductLineItem() {
          const products = this.$store.cartDrawerStore.products;
          const index = products.findIndex((product) => product.id === this.variant.id);
          return index + 1;
        },

        disableQuantitySelector() {
          // this.$root.classList.add('disabled');
          this.$refs.ctrQuantityBox.classList.add('disabled');
        },

        enableQuantitySelector() {
          // this.$root.classList.remove('disabled');
          this.$refs.ctrQuantityBox.classList.remove('disabled');
        },

        async updateCart() {
          this.disableQuantitySelector();

          const data = {
            line: this.getProductLineItem(),
            quantity: this.quantity,
            sections: []
          };

          const cartItemsComponents = document.querySelectorAll('cart-items-component');
          let cartItemComponentsSectionIds = [];

          cartItemsComponents.forEach((item) => {
            if (item instanceof HTMLElement && item.dataset.sectionId) {
              cartItemComponentsSectionIds.push(item.dataset.sectionId);
            }

            data.sections.push(item.dataset.sectionId);
          });

          const response = await fetch(`${Theme.routes.cart_change_url}`,
            window.fetchConfig("json", {
              body: JSON.stringify(data),
            })
          );

          const responseText = await response.text();
          const parsedResponseText = JSON.parse(responseText);
          const sectionId = this.$store.cartDrawerStore.cartDrawerSectionId;

          const newSectionHTML = new DOMParser().parseFromString(
            parsedResponseText.sections[sectionId],
            "text/html"
          );

          // Grab the new cart item count from a hidden element
          const newCartHiddenItemCount = newSectionHTML.querySelector(
            '[ref="cartItemCount"]'
          )?.textContent;
          const newCartItemCount = newCartHiddenItemCount
            ? parseInt(newCartHiddenItemCount, 10)
            : 0;

          window.dispatchEvent(
            new CartUpdateEvent({}, sectionId, {
              itemCount: newCartItemCount,
              source: "product-card-alp",
              sections: parsedResponseText.sections,
            })
          );

          const morphCart =
            typeof window.morphCartPortion === "function"
              ? window.morphCartPortion
              : window.morphSection;

          morphCart(sectionId, parsedResponseText.sections[sectionId]);

          this.enableQuantitySelector();
          window.dispatchEvent(new CustomEvent('cart-drawer-store:update'));
        },

        onChangeQuantity(event) {
          this.quantity = Number(event.target.value);
          this.updateCart();
        },

        /**
         * @param {number | null} newSellingPlanId
         * @param {number | null} oldSellingPlanId
         */
        handleSellingPlanChange(newSellingPlanId, oldSellingPlanId) {
          if (this.variant.selling_plan_groups?.length > 0) {
            this.sellingPlanId =
              this.variant.selling_plan_groups
                .find((group) => group.app_id === "SKIO")
                ?.selling_plans.find((plan) => plan.id === newSellingPlanId)?.id ||
              null;
            return this.sellingPlanId;
          }

          if (this.variant.selling_plan_allocations?.length > 0) {
            this.sellingPlanId =
              this.variant.selling_plan_allocations?.find(
                /** @param {{selling_plan_id: number | null}} allocation */
                (allocation) => allocation.selling_plan_id === newSellingPlanId
              )?.selling_plan_id || null;
            return this.sellingPlanId;
          }

          this.sellingPlanId = null;
          return this.sellingPlanId;
        },
      }
    });

    /**
     * @param {{product: {selling_plan_groups: Array<{selling_plans: Array<{id: number | null, name: string}>}>}}} product
     * @returns {Array<{id: number | null, name: string}>}
     */
    function getSellingPlan(sellingPlanId) {
      if (variant.selling_plan_allocations?.length > 0) {
        return variant.selling_plan_allocations.map(
          (allocation) => allocation.selling_plan_id
        );
      }

      if (variant.selling_plan_groups?.length > 0) {
        const skioGroup = variant.selling_plan_groups.find(
          (group) => group.app_id === "SKIO"
        );
        if (skioGroup) {
          return skioGroup.selling_plans.map((plan) => ({
            id: plan.id,
            name: plan.name,
          }));
        }
      }

      return [];
    }
});
